import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import styled from 'styled-components';
import { Container } from '../../global-styles'
import { GiIronMask } from "react-icons/gi";
import { FaTimes, FaBars } from "react-icons/fa";
import logo from '../../assets/vinayak.png'
import * as ROUTES from '../../constants/routes'

export default function Navbar(){

    const [click, setClick] = useState(false);

    const handleClick = () =>{
        setClick(!click);
    }

    return(
        <React.Fragment>
            <Nav>
                <NavBarContainer>
                    <NavLogo to="/">
                        <NavIcon />
                        <NavPersonalLogo src={logo} alt="vinayak" />
                    </NavLogo>
                    <Hamburger onClick={handleClick}>
                        { click ? <FaTimes /> : <FaBars />}
                    </Hamburger>
                    <NavMenu onClick={handleClick} click={click}>
                        <NavItem>
                            <NavLinks to={ROUTES.HOME}>
                                Home
                            </NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to={ROUTES.ABOUT}>
                                About
                            </NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to={ROUTES.PROJECTS}>
                                Projects
                            </NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to={ROUTES.HIRE_ME}>
                                Hire Me
                            </NavLinks>
                        </NavItem>
                    </NavMenu>
                </NavBarContainer>
            </Nav>
        </React.Fragment>
    )
}

const Nav = styled.div`
    background-color: #000;
    height:80px;
    display:flex;
    justify-content:center;
    align-items:center;
    font-size:1.2rem;
    top: 0;
    position:sticky;
    z-index:999;

`;

const NavBarContainer = styled(Container)`
    background: #000000;
    display:flex;
    justify-content:space-between;
    height:80px;
    box-sizing: border-box;
    border-bottom: 1px solid #474747;

    &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: -webkit-gradient(linear, left top, right top, from(#E39600), color-stop(#EA4C89), color-stop(#8F48EB), to(#1DA1F2));
    background: linear-gradient(to right, #E39600, #EA4C89, #8F48EB, #1DA1F2);
`;

const NavLogo = styled(Link)`
    color: #fff;
    font-weight: bold;
    font-size: 1.5rem;
    display:flex;
    align-items:center;
    justify-self: start;
    text-decoration: none;
    cursor: pointer;
`;

const NavIcon = styled(GiIronMask)`
    margin-right: 0.5rem;
`;

const NavPersonalLogo = styled.img``;

const Hamburger = styled.div`
    display: none;
    color: #fff;

    @media screen and (max-width: 960px) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        font-size: 1.8rem;
        cursor: pointer;
        transform: translate(-100%, 60%);
    }
`;


const NavMenu = styled.ul`
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    padding: 0;

    @media screen and (max-width: 960px){
        left: -100%;
        background: rgba(0,0,0,0.8);
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100vh;
        position: absolute;
        top: 80px;
        left: ${({click}) => (click ? 0 : '-100%')};
        transition: all 0.5s ease;
    }
`;

const NavItem = styled.li`
    display: flex;
    align-items:center;
    justify-content: center;
    margin: 0 0.125rem;

`;

const NavLinks = styled(Link)`
    text-decoration: none;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content:center;
    font-weight: 600;
    height: fit-content;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    letter-spacing: 0.1em;

    @media screen and (min-width: 960px) {
        
        &:hover {
            background: rgba(130,130,130,0.5);
        }       
    }
    
    @media screen and (max-width: 960px) {

        text-align:center;
        padding: 2rem;
        width:100%;
        display:table;

        &:hover{
            color: #5f27cd;
            transition: all 0.3s ease-in;
        }
             
    }

`;